{
  "NO_MERCHANT": {
    "message": "ไม่พบร้านค้า กรุณาออกจากระบบและเข้าใหม่"
  },
  "CANNOT_MODIFY_OWNER": {
    "message": "ไม่สามารถแก้ไขสิทธิ์ของเจ้าของร้านได้"
  },
  "CANNOT_MODIFY_SELF": {
    "message": "ไม่สามารถแก้ไขสิทธิ์ของตนเองได้"
  },
  "CANNOT_REMOVE_OWNER": {
    "message": "ไม่สามารถลบเจ้าของร้านออกจากทีมได้"
  },
  "CANNOT_REMOVE_SELF": {
    "message": "ไม่สามารถลบตนเองออกจากทีมได้"
  },
  "SUBSCRIPTION_EXPIRED": {
    "title": "แพ็กเกจหมดอายุ",
    "message": "สมัครแพ็กเกจเพื่อใช้งานต่อ",
    "actionLabel": "ซื้อแพ็กเกจ"
  },
  "ADDON_REQUIRES_PAID_PLAN": {
    "message": "ต้องมีแพ็กเกจที่ชำระเงินแล้วก่อนซื้อที่นั่งเพิ่ม"
  },
  "ADDON_QTY_DECREASE_NOT_ALLOWED": {
    "message": "ไม่สามารถลดที่นั่งเสริมผ่านการต่ออายุได้ กรุณาเลือกจำนวนเท่าเดิมหรือมากกว่า"
  },
  "NO_REMAINING_TERM": {
    "message": "ต้องมีแพ็กเกจที่ชำระเงินแล้วก่อนซื้อที่นั่งเพิ่ม"
  },
  "IDEMPOTENCY_KEY_MISMATCH": {
    "message": "ตะกร้ามีการเปลี่ยนแปลง กรุณาลองอีกครั้ง"
  },
  "TOO_MANY_PENDING_ORDERS": {
    "title": "มีคำสั่งซื้อรอชำระ",
    "message": "ชำระหรือยกเลิกคำสั่งซื้อที่ค้างอยู่ก่อนสร้างใหม่",
    "actionLabel": "ไปดูคำสั่งซื้อ"
  },
  "PENDING_ORDER_EXISTS": {
    "title": "มีคำสั่งซื้อรอชำระ",
    "message": "ชำระหรือยกเลิกคำสั่งซื้อที่ค้างอยู่ก่อนสร้างใหม่",
    "actionLabel": "ไปดูคำสั่งซื้อ"
  },
  "PERSIST_FAILED": {
    "title": "ระบบบันทึกคำสั่งซื้อไม่สำเร็จ",
    "message": "ทีมงานได้รับแจ้งแล้ว กรุณาอย่าชำระเงินซ้ำ"
  },
  "PAYMENT_PROVIDER_ERROR": {
    "message": "ระบบชำระเงินขัดข้อง กรุณาลองอีกครั้งภายหลัง"
  },
  "INVALID_TOTAL": {
    "message": "ยอดคำสั่งซื้อไม่ถูกต้อง"
  },
  "RECEIPT_PROFILE_REQUIRED": {
    "message": "กรุณากรอกข้อมูลใบเสร็จรับเงินก่อนชำระเงิน"
  },
  "RATE_LIMITED": {
    "message": "อัปโหลดบ่อยเกินไป กรุณารอสักครู่"
  },
  "QUOTA_EXCEEDED": {
    "title": "ถึงจำนวนรูปสูงสุดของแพ็กเกจ",
    "message": "อัปเกรดแพ็กเกจเพื่อเพิ่มความจุ หรือลบรูปเก่าออก",
    "actionLabel": "อัปเกรดแพ็กเกจ"
  },
  "INVALID_FILE_TYPE": {
    "message": "ไฟล์ไม่ใช่รูปภาพที่รองรับ (PNG / JPEG / WEBP / GIF เท่านั้น)"
  },
  "PAYLOAD_TOO_LARGE": {
    "message": "ไฟล์ใหญ่เกินไป (สูงสุด 1 MB)"
  },
  "IMAGE_DIMENSIONS_TOO_LARGE": {
    "message": "รูปมีขนาดใหญ่เกินไป (สูงสุด 25 ล้านพิกเซล)"
  },
  "UPLOAD_FAILED": {
    "message": "อัปโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่"
  },
  "MERCHANT_CHANNEL_LIMIT": {
    "message": "แพลตฟอร์มนี้มีช่องทางที่ใช้งานอยู่แล้ว 1 ช่อง กรุณาปิดช่องนั้นก่อน"
  },
  "SELECT_ONE_PAGE_FIRST": {
    "message": "กรุณาเลือก Facebook Page เพียง 1 รายการ"
  },
  "SELECT_ONE_ACCOUNT_FIRST": {
    "message": "กรุณาเลือกบัญชี Instagram เพียง 1 รายการ"
  },
  "LINE_TOKEN_INVALID": {
    "message": "Access Token LINE ไม่ถูกต้อง"
  },
  "MISSING_ACCESS_TOKEN": {
    "message": "ไม่พบ Access Token"
  },
  "FB_NO_PAGES": {
    "message": "ไม่พบ Facebook Page ที่อนุญาตให้เชื่อมต่อ"
  },
  "IG_NO_ACCOUNTS": {
    "message": "ไม่พบบัญชี Instagram Business ที่อนุญาตให้เชื่อมต่อ"
  },
  "INVALID_STATE": {
    "message": "การยืนยันตัวตนไม่ถูกต้อง กรุณาเริ่มใหม่"
  },
  "UNSUPPORTED_PLATFORM": {
    "message": "แพลตฟอร์มยังไม่รองรับ"
  },
  "CHANNEL_NOT_FOUND": {
    "message": "ไม่พบช่องทางที่เลือก"
  },
  "CHANNEL_REAUTH_REQUIRED": {
    "message": "ช่องทางนี้ขาดการเชื่อมต่อ กรุณาเชื่อมต่อใหม่ในหน้าตั้งค่า"
  },
  "CHANNEL_INACTIVE": {
    "message": "ช่องทางนี้ถูกปิดอยู่ กรุณาเปิดใช้งานในหน้าตั้งค่าช่องทาง"
  },
  "TOKEN_CHECK_FAILED": {
    "message": "ไม่สามารถตรวจสอบสถานะช่องทางได้ กรุณาลองใหม่"
  },
  "PAGE_ALREADY_OWNED_BY_OTHER_MERCHANT": {
    "message": "บัญชีนี้ถูกเชื่อมต่อกับร้านอื่นอยู่แล้ว กรุณายกเลิกเชื่อมต่อที่ร้านนั้นก่อน"
  },
  "INVALID_CATEGORY_ID": {
    "message": "หมวดสินค้าที่เลือกไม่ถูกต้อง กรุณาเลือกหมวดใหม่"
  },
  "FB_TOKEN_INVALID": {
    "message": "การเชื่อมต่อ Facebook หมดอายุ กรุณาเชื่อมต่อใหม่ในหน้าตั้งค่า"
  },
  "IG_TOKEN_INVALID": {
    "message": "การเชื่อมต่อ Instagram หมดอายุ กรุณาเชื่อมต่อใหม่ในหน้าตั้งค่า"
  },
  "FB_POLICY_BLOCKED": {
    "message": "ลูกค้าไม่ได้ทักมาเกิน 24 ชั่วโมง — ต้องรอให้ลูกค้าส่งข้อความก่อนถึงจะตอบกลับได้"
  },
  "IG_POLICY_BLOCKED": {
    "message": "ลูกค้าไม่ได้ทักมาเกิน 24 ชั่วโมง — ต้องรอให้ลูกค้าส่งข้อความก่อนถึงจะตอบกลับได้"
  },
  "FB_BAD_RESPONSE": {
    "message": "Facebook ตอบกลับไม่ถูกต้อง กรุณาลองใหม่"
  },
  "IG_BAD_RESPONSE": {
    "message": "Instagram ตอบกลับไม่ถูกต้อง กรุณาลองใหม่"
  },
  "LINE_API_ERROR": {
    "message": "LINE API มีปัญหา กรุณาลองใหม่"
  },
  "LINE_BAD_RESPONSE": {
    "message": "LINE ตอบกลับไม่ถูกต้อง กรุณาลองใหม่"
  },
  "LINE_QUOTA_EXHAUSTED": {
    "message": "โควต้าข้อความ LINE เดือนนี้ของคุณหมดแล้ว กรุณาอัปเกรดแพ็กเกจ LINE เพื่อตอบลูกค้าต่อ"
  },
  "TIKTOK_BAD_RESPONSE": {
    "message": "TikTok ตอบกลับไม่ถูกต้อง กรุณาลองใหม่"
  },
  "ALREADY_ACCEPTED": {
    "message": "คำเชิญถูกรับไปแล้ว"
  },
  "INVITATION_NOT_FOUND": {
    "message": "ไม่พบคำเชิญหรือคำเชิญหมดอายุแล้ว"
  },
  "INVITATION_ALREADY_CLAIMED": {
    "message": "คำเชิญถูกใช้ไปแล้ว"
  },
  "EMAIL_MISMATCH": {
    "message": "อีเมลของคุณไม่ตรงกับคำเชิญ"
  },
  "USER_ALREADY_MEMBER": {
    "message": "คุณเป็นสมาชิกของร้านนี้อยู่แล้ว"
  },
  "SELF_INVITE": {
    "message": "ไม่สามารถเชิญตัวเองได้"
  },
  "INVITE_COOLDOWN": {
    "message": "กรุณารอสักครู่ก่อนส่งคำเชิญใหม่"
  },
  "SKU_INACTIVE": {
    "message": "SKU นี้ปิดใช้งานอยู่"
  },
  "SKU_ALREADY_EXISTS": {
    "message": "SKU นี้มีอยู่แล้ว"
  },
  "ORDER_ALREADY_PAID": {
    "message": "คำสั่งซื้อชำระเงินแล้ว"
  },
  "INVALID_TRANSITION": {
    "message": "ไม่สามารถเปลี่ยนสถานะนี้ได้"
  },
  "CONVERSATION_NOT_FOUND": {
    "message": "ไม่พบการสนทนา"
  },
  "CONVERSATION_CUSTOMER_MISMATCH": {
    "message": "การสนทนานี้ไม่ตรงกับลูกค้าที่เลือก"
  },
  "BOT_ACTION_EXPIRED": {
    "message": "ข้อเสนอนี้หมดอายุแล้ว ให้บอทเสนอราคาใหม่อีกครั้ง"
  },
  "BOT_ACTION_NOT_PENDING": {
    "message": "รายการนี้ถูกดำเนินการไปแล้ว"
  },
  "BOT_ACTION_ALREADY_EXECUTED": {
    "message": "ออเดอร์นี้ถูกอนุมัติไปแล้ว"
  },
  "BOT_ACTION_NOT_FOUND": {
    "message": "ไม่พบรายการที่บอทเสนอ (อาจถูกดำเนินการไปแล้ว)"
  },
  "BOT_ACTION_NO_CUSTOMER": {
    "message": "รายการนี้ยังไม่ได้ผูกกับลูกค้า ไม่สามารถสร้างออเดอร์ได้"
  },
  "AI_CONFIG_NOT_FOUND": {
    "message": "ยังไม่ได้ตั้งค่าผู้ช่วย AI"
  },
  "INSUFFICIENT_STOCK": {
    "message": "สินค้าในสต็อกไม่เพียงพอ"
  },
  "POLICY_NOT_FOUND": {
    "message": "ไม่พบนโยบายที่ยอมรับ"
  },
  "EMAIL_PROVIDER_UNREACHABLE": {
    "message": "ระบบอีเมลขัดข้อง กรุณาลองใหม่อีกครั้ง"
  },
  "EMAIL_NOT_CONFIGURED": {
    "message": "ระบบอีเมลยังไม่พร้อมใช้งาน"
  },
  "EMAIL_TOO_LARGE": {
    "message": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
  },
  "FALLBACK": {
    "message": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
  },
  "FORBIDDEN": {
    "message": "ไม่มีสิทธิ์ทำรายการนี้"
  },
  "PRODUCT_NOT_FOUND": {
    "message": "ไม่พบสินค้า"
  },
  "SKU_NOT_FOUND": {
    "message": "ไม่พบ SKU"
  },
  "CUSTOMER_NOT_FOUND": {
    "message": "ไม่พบลูกค้า"
  },
  "ORDER_NOT_FOUND": {
    "message": "ไม่พบคำสั่งซื้อ"
  },
  "USER_NOT_FOUND": {
    "message": "ไม่พบบัญชีผู้ใช้"
  }
}
